import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import { useLazyQuery } from '@apollo/client'
import { Row, Col, Button } from 'react-bootstrap'

import { isBottomReached, getStringJoinByDash } from '@shared-submodule/utils'
import { LIST_AUTHORS } from '@graphql/author/author.query'
import { authorListLoader } from '@shared/libs/allLoader'
import Error from '@shared/components/error'
import { RightArrow } from '../ctIcons'

const AuthorListCard = dynamic(() => import('./authorListCard'), { loading: () => authorListLoader(2) })

function AuthorList({ list }) {
  const [startLoadMore, setStartLoadMore] = useState(list?.aResults?.length >= 8)
  const [authorList, setAuthorList] = useState(list?.aResults)
  const loading = useState(false)
  const payloads = useRef({ nLimit: 8, nSkip: 2 })
  const total = useRef(list?.nTotal)
  const [isLoading, setIsLoading] = useState(false)

  const [getAuthorList, { data: newAuthorData }] = useLazyQuery(LIST_AUTHORS, {
    variables: { input: payloads.current },
    onCompleted: (data) => {
      setStartLoadMore(false)
    }
  })

  function startLoadMoreFlagSet() {
    getAuthorList()
  }

  useEffect(() => {
    if (authorList?.length > 17) {
      loading.current = false
      setIsLoading(false)
      const lastAuthorListItem = authorList[authorList.length - 1]
      const authorListItemID = lastAuthorListItem?.oSeo?.sSlug || getStringJoinByDash(lastAuthorListItem?.sFName)
      isBottomReached(authorListItemID, isReached)
    }
  }, [authorList])

  useEffect(() => {
    const authorListResponse = newAuthorData?.listAuthors
    const totalAuthors = authorListResponse?.aResults
    if (totalAuthors && totalAuthors.length) {
      setAuthorList([...authorList, ...totalAuthors])
      total.current = authorListResponse.nTotal
    }
  }, [newAuthorData])

  function isReached(reach) {
    if (!loading.current && reach && authorList?.length < total.current) {
      loading.current = true
      setIsLoading(true)
      setPayload()
    }
  }

  function setPayload() {
    payloads.current = { ...payloads.current, nSkip: payloads.current.nSkip + 1 }
    getAuthorList()
  }

  return (
    <>
      <Row>
        {authorList?.map((authorData) => (
          <Col key={authorData._id} xl={3} lg={4} md={6} sm={6} xs={6}>
            <AuthorListCard data={authorData} />
          </Col>
        ))}
        {isLoading && (
          <>
            <Col md="3" sm="6">
              {authorListLoader(1)}
            </Col>
            <Col md="3" sm="6">
              {authorListLoader(1)}
            </Col>
            <Col md="3" sm="6">
              {authorListLoader(1)}
            </Col>
            <Col md="3" sm="6">
              {authorListLoader(1)}
            </Col>
          </>
        )}
      </Row>
      {startLoadMore && (
        <div className="text-center mb-3">
          <Button className="theme-btn" onClick={() => startLoadMoreFlagSet()}>
            {'Load more'}
            <RightArrow />
          </Button>
        </div>
      )}
    </>
  )
}

AuthorList.propTypes = {
  list: PropTypes.object
}

AuthorList.defaultProps = {
  list: []
}

export default Error(AuthorList)
